<script>
  import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Button,
    Spinner
  } from "sveltestrap";
  import axios from "axios";
import { createEventDispatcher } from 'svelte';
  export let open;
  export let toggle;
  export let propertyId;
  export let deliverableId;
  let floorName;
  let notes;
  let floorLabel;
  let floorOrder;
  let completed = false;
  let errorMessages = [];
  let saving = false;

  const dispatch = createEventDispatcher();

  function AddFloor() {
    errorMessages.pop();
    errorMessages.pop();
    errorMessages.pop();
    if (floorOrder == undefined) {
      errorMessages.push("FloorOrder is Required.");
    }
    if (floorLabel == undefined) {
      errorMessages.push("FloorLabel is Required.");
    }
    if (floorName == undefined) {
      errorMessages.push("FloorName is Required.");
    }

    if (notes == undefined) {
      notes = "";
    }
    errorMessages = errorMessages;
    console.log(errorMessages);
    if (
      floorLabel != undefined &&
      floorName != undefined &&
      floorOrder != undefined
    ) {
      saving = true;
      var bodyFormData = new FormData();
      bodyFormData.set("PropertyId", propertyId);
      bodyFormData.set("Completed", completed);
      bodyFormData.set("Notes", notes);
      bodyFormData.set("FloorOrder", floorOrder);
      bodyFormData.set("FloorName", floorName);
      bodyFormData.set("FloorLabel", floorLabel);
      axios({
        method: "post",
        url: "/jobboardapi/AddFloor",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(function(response) {
          propertyId = "";
          completed = "";
          notes = "";
          floorOrder = "";
          floorName = "";
          floorLabel = "";
          saving = false;
          document.getElementById(deliverableId + "-edit").click();
          document.getElementById(deliverableId).click();
          toggle();
          dispatch('floorAdded');
        })
        .catch(function(response) {
          console.log(response);
        });
    }
  }
</script>

<style>
  input {
    width: 100%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }
  .row-container {
    margin-bottom: 10px;
  }
</style>

<Modal isOpen={open} {toggle}>
  <ModalHeader {toggle}>Add Floor</ModalHeader>
  <ModalBody>
    <div class="row-container">
      <label>Floor Name</label>
      <input type="text" bind:value={floorName} required />
    </div>
    <div class="row-container">
      <label>Notes</label>
      <input type="text" bind:value={notes} />
    </div>
    <div class="row-container">
      <label>Floor Label</label>
      <input type="text" bind:value={floorLabel} required />
    </div>
    <div class="row-container">
      <label>Floor Order</label>
      <input type="number" bind:value={floorOrder} required />
    </div>
    <div
      class="row-container"
      style="text-align:center; background-color: #eb4d4b; color: white;">
      {#each errorMessages as errorMessage}
        <p>{errorMessage}</p>
      {/each}
    </div>
  </ModalBody>
  <ModalFooter>
    {#if saving}
      <Button color="primary" disabled>
        <Spinner size="sm" />
        Saving
      </Button>
    {:else}
      <Button color="primary" on:click={AddFloor}>Save</Button>
    {/if}
    <Button color="secondary" on:click={toggle}>Cancel</Button>
  </ModalFooter>
</Modal>
